export const MeetingMode = {
    VIDEO: 'Video',
    AUDIO: 'Audio',
    PHONE: 'Phone',
    FACE_TO_FACE: 'Face to Face'
}